<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">B. PROGRAM INFORMATION</p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span v-if="menu.value2 != null">{{ menu.value }} / {{ menu.value2 }}</span>
                                    <span v-else>{{ menu.value }}</span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox
                                    >

                                   <p>
                                       I read and confirm that I understand the information in Section B.

                                   </p>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>

            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";


export default {
    data() {
        return {
            form: {},
            data: []
        }
    },

    created() {
        this.getData()
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        })
    },
    methods: {
        async getData() {
            window.scrollTo(0,0)
            this.changeYear(this.formData)
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }

        },
        async changeYear(data) {
            this.data.push(
                {
                    key: 'Program Of Study',
                    value: data.program_name,
                },

                {
                    key: 'Program Start Date',
                    value: data.active_module_start_date,
                },

                {
                    key: 'Registration Type',
                    value: data.registration_type_text ? data.registration_type_text : null,
                },
                {
                    key: 'Enrollment Status',
                    value: data.student_status_text,
                },
                 {
                    key: 'Initial CEFR Level',
                    value: data.cefr_level ? data.cefr_level : null,
                }

            )

            await this.$store.dispatch('enrollmentAgreementForm/deleteFormData');
            await this.$store.dispatch('enrollmentAgreementForm/saveFormData',data);

        },

    back() {
        this.$emit('back', -1);
    }
}
}
</script>
<style scoped>
.text-sm {
    font-size: 0.875rem;
}
.text-md-md {
    font-size: 1rem;
}

/* Kalın metinler için stil */
.font-weight-bold {
    font-weight: 700;
}
.font-weight-bold.text-sm {
    font-size: 0.875rem;
}
@media (min-width: 768px) {
    .font-weight-bold.text-md-md {
        font-size: 1rem;
    }
}

/* Hata mesajı için responsive stil */
.b-form-invalid-feedback.text-sm {
    font-size: 0.75rem;
}
@media (min-width: 768px) {
    .b-form-invalid-feedback {
        font-size: 0.875rem;
    }
}

.b-list-group-item {
    transition: background-color 0.2s ease;
}
.b-list-group-item:hover {
    background-color: #f8f9fa;
}

.b-button {
    transition: all 0.2s ease;
}
</style>
